import React from 'react';
import { Stack, Typography } from '@mui/material';
import BaseModal from '@/components/modal/BaseModal';

interface AlreadyConfirmedModalProps {
  showModal: boolean;
  handleShowModal: () => void;
  storeName: string;
}

const AlreadyConfirmedModal: React.FC<AlreadyConfirmedModalProps> = ({ showModal, handleShowModal, storeName }) => {
  return (
    <BaseModal
      showModal={showModal}
      handleShowModal={handleShowModal}
      modalTitle="병원 인증 불가"
      buttons={{
        primary: {
          title: '확인',
          onClick: handleShowModal
        }
      }}
      style={{ maxWidth: '446px', height: 'auto' }}
    >
      <Stack gap="24px" width="100%" paddingX="20px">
        <Typography variant="subtitle1" sx={{ textAlign: 'left' }}>
          {storeName}은(는) 이미 다른 조직에 속해 있습니다.
        </Typography>
        <Typography variant="subtitle2" sx={{ textAlign: 'left', fontWeight: 'bold' }}>
          인증이 필요하시면, 리뷰웍스 (1577-9325)로 문의주세요.
        </Typography>
      </Stack>
    </BaseModal>
  );
};

export default AlreadyConfirmedModal;
